<div class="col-12 justify-content-center no-gutters py-3" *ngIf="isShow">
  <div class="text-title" *ngIf="!isEditMode">{{type === 'application-training-document-admin' ? 'Add Application' : 'Add Document'}}</div>
  <div class="text-title" *ngIf="isEditMode">{{type === 'application-training-document-admin' ? 'Modify Application' : 'Modify Document'}}</div>
  <form [formGroup]="regiForm" class="row justify-content-center pt-4">
    <div class="col-12 pb-2">
      <span>
        Application Name
        <span style="color: red;">*</span>
      </span>
    </div>
    <mat-form-field floatLabel="never" appearance="outline" class="col-12">
      <input formControlName="name" name="name" #name matInput maxlength="50">
      <mat-hint align="end">{{name.value.length}} / 50</mat-hint>
    </mat-form-field>
    <div class="col-12 pb-2">
      <span>Thumbnail Image
      </span>
    </div>
    <div class="row col-12 pb-2 pr-0">
      <div class="avatar-upload">
        <div class="avatar-edit">
          <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileImgInput (change)="uploadFile($event)"
            style="display: none" name="thumbnail" />
        </div>
        <div class="avatar-preview">
          <img [src]="imageUrl" alt="" id="imagePreview" (click)="fileImgInput.click()">
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-sm-12 col-12 align-self-center" *ngIf="regiForm.controls.thumbnail.value">
        <div class="col-12 pb-3">
          <button class="btn btn-outline-primary size-button" type="button" (click)=previewImg()>
            Preview
          </button>
        </div>
        <div class="col-12">
          <button class="btn btn-outline-primary size-button" type="button" (click)=removeImg()>
            Remove
          </button>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-sm-12 col-12 align-self-center" *ngIf="!regiForm.controls.thumbnail.value">
        No file choosen
      </div>
    </div>
    <div formArrayName="materials" class="col-12 px-0 pr-0">
      <div *ngFor="let materialForm of regiForm['controls'].materials['controls']; let idx=index"
        class="col-12 px-0 pr-0">
        <div [formGroup]="materialForm" class="row col-12 px-0 pr-0">
          <div class="row no-gutters col-12 d-flex align-items-center justify-content-end p-0">
            <mat-icon mat-list-icon (click)="deleteMaterial(idx)" [matTooltip]="'Remove'">
              close
            </mat-icon>
          </div>
          <div class="col-xl-5 col-md-5 col-sm-12 col-12 pr-0">
            <div class="col-12 pb-2 pr-0">
              <span>
                Material Name
                <span style="color: red;">*</span>
              </span>
            </div>
            <mat-form-field floatLabel="never" appearance="outline" class="col-12 pr-0">
              <input formControlName="materialName" name="materialName" #materialName matInput maxlength="50">
              <mat-hint align="end">{{materialName.value.length}} / 50</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-xl-2 col-md-2 col-sm-12 col-12 pr-0">
            <div class="col-12 pb-2 pr-0">
              <span>Type
              </span>
            </div>
            <mat-form-field floatLabel="never" appearance="outline" class="col-12 pr-0">
              <mat-select formControlName="type" (selectionChange)="selectTypeMaterial(materialForm, $event)">
                <mat-option *ngFor="let item of types" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xl-5 col-md-5 col-sm-12 col-12 pr-0">
            <div class="col-12 pb-2 pr-0">
              <span>
                URL
                <span style="color: red;" *ngIf="materialForm?.value?.type === tyeFile.KEY_VIDEO">*</span>
              </span>
            </div>
            <mat-form-field floatLabel="never" appearance="outline" class="col-12 pr-0">
              <input formControlName="url" name="url" matInput>
              <mat-error *ngIf="materialForm.controls['type'].value === tyeFile.KEY_VIDEO
                        && materialForm.controls['url'].hasError('noVideoUrl')">
                Please enter a valid URL for video (embedded video URL or
                end with video format e.g. ".mp4"). Protocol is required (http://, https:// or ftp://).
              </mat-error>
              <mat-error *ngIf="materialForm.controls['type'].value === tyeFile.KEY_DOCUMENT
                        && materialForm.controls['url'].hasError('noDocumentUrl')">
                Please enter a valid URL for documents. Protocol is required (http://, https:// or ftp://)
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 pr-0" *ngIf="materialForm?.value?.type === tyeFile.KEY_DOCUMENT">
            <div class="col-12 pb-2 pr-0">
              <span>or upload file (Only upload jpg, pdf, doc, docx, xls, xlsx, ppt, pptx and 10MB max file)
              </span>
            </div>
            <div class="row col-12 pb-2 pr-0">
              <div class="row col-xl-2 col-md-2 col-sm-12 col-12 no-gutters py-2 pr-0">
                <button class="btn btn-outline-primary size-button" type="button" (click)=fileInput.click()>
                  Choose file
                </button>
                <input #fileInput type="file" name="file-input" style="display: none" accept=".pdf, .doc, .xlsx, .xls, .docx, .jpg, .jpeg, .ppt, .pptx"
                  (change)="onFileInput($event, materialForm)" id="docFile" />
              </div>
              <div class="row col-xl-2 col-md-2 col-sm-12 col-12 align-items-center py-2 pr-0 col-sxl"
                *ngIf="materialForm?.controls?.resource?.value && !materialForm?.controls?.resource?.value?.resourceId">
                <button class="btn btn-primary button" (click)="submitMaterialForm(materialForm)">
                  Save file
                </button>
              </div>
              <div class="row col-xl-8 col-md-8 col-sm-12 col-12 no-gutters align-items-center py-2 pr-0 col-sxl"
                *ngIf="materialForm?.controls?.resource?.value">
                <div class="pr-3 col-10 ellipsis"
                  [matTooltip]="materialForm?.controls?.resource?.value?.name || materialForm?.controls?.resource?.value?.resourceName">
                  {{ materialForm?.controls?.resource?.value?.name || materialForm?.controls?.resource?.value?.resourceName}}
                </div>
                <mat-icon aria-label="attach file" (click)="removeAttachment(materialForm)" [matTooltip]="'Remove'">
                  close
                </mat-icon>
              </div>
              <div class="row col-xl-3 col-md-3 col-sm-12 col-12 align-items-center pr-0 col-sxl"
                *ngIf="!materialForm?.controls?.resource?.value">
                <div class="pr-3">No file choosen</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <hr>
        </div>
      </div>
      <div class="col-12">
        <button type="button" class="btn btn-link" (click)="addMaterial()">Add Material</button>
      </div>
    </div>
  </form>
  <div class="row no-gutters col-12 d-flex align-items-center justify-content-center pt-4">
    <button class="btn btn-primary button col-xl-2 col-md-2 col-sm-12 col-12" [disabled]="isEditMode && !regiForm.dirty"
      (click)="submitRegiForm()">
      <span>
        SAVE
      </span>
    </button>
  </div>
</div>